import { render, staticRenderFns } from "./messageArea.vue?vue&type=template&id=2f8f4bb1"
import script from "./messageArea.vue?vue&type=script&lang=js"
export * from "./messageArea.vue?vue&type=script&lang=js"
import style0 from "./messageArea.vue?vue&type=style&index=0&id=2f8f4bb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports